<template>
    <div class="home-view">
        <BaseBanner />
        <CardSection />
    </div>
</template>
